import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad184960"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "reading-list-callout"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont iclose" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "reading-list-callout__text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "reading-list-callout__title" }, " Check your first reading list in My Library ", -1))
const _hoisted_6 = { class: "reading-list-callout__covers" }
const _hoisted_7 = ["src"]

import { computed, ref } from 'vue'

import { storage } from '@/helpers/storage'

import AppButton from '@/app/components/button/AppButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReadingListCallout16167',
  setup(__props) {

const isOpen = ref(true)

const covers = computed(() => {
  const covers = storage.getItem('sf_lq_books16167')
  if (!covers || !isOpen.value) {
    return null
  }

  return JSON.parse(covers) as string[]
})

function clearLibraryData(): void {
  isOpen.value = false
  storage.removeItem('sf_lq_books16167')
}

return (_ctx: any,_cache: any) => {
  return (_unref(covers))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "reading-list-callout__close",
          onClick: clearLibraryData
        }, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(AppButton, {
            tag: "router-link",
            to: { name: 'my_library.custom_lists' },
            class: "reading-list-callout__link",
            onClick: clearLibraryData
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Open My Library ")
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(covers).slice(0, 5), (cover) => {
            return (_openBlock(), _createElementBlock("img", {
              key: cover,
              src: cover,
              width: "62",
              height: "83",
              alt: "",
              class: "reading-list-callout__cover"
            }, null, 8, _hoisted_7))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})